// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import Container from '../../../common/container/Container'
import Header, { Tab } from '../../header/Header'
import { i18n } from '../../index'
import CampaignsPage from '../campaigns/CampaignsPage'
import ChainRemindersPage from '../chainReminders/ChainRemindersPage'
import ChainChecklistPage from '../checklist/ChainChecklistPage'
import ChainIncentiveProductPage from '../incentiveProduct/ChainIncentiveProductPage'
import MarketQuestionPage from '../marketQuestion/MarketQuestionPage'
import { ChainMarketSettingsPage } from '../marketSettings/ChainMarketSettingsPage'
import ScoreCardThresholdsPage from '../scoreCardThresholds/ScoreCardThresholdsPage'
import ChainShiftResponsibilityPage from '../shiftResponsibility/ChainShiftResponsibilityPage'
import ChainThumbableServicePage from '../thumbableService/ChainThumbableServicePage'
import ChainToiletCheckQuestionPage from '../toiletCheckQuestion/ChainToiletCheckQuestionPage'
import css from './chainRoot.css'
import ChainSettings from './chainSettings/ChainSettings'
type Props = {
  history: any
  location: any
  match: any
}

class ChainRoot extends React.PureComponent<Props> {
  getTabs = (): Tab[] => {
    const tabs = [
      {
        label: i18n.t('admin.chain.tab.incentiveProducts'),
        value: 'aloitteellisen-myynnin-tuotteet',
      },
      {
        label: i18n.t('admin.chain.tab.marketQuestions'),
        value: 'marketin-tehtavat',
      },
      {
        label: i18n.t('admin.chain.tab.thumbableServices'),
        value: 'peukutettavat-palvelut',
      },
      {
        label: i18n.t('admin.chain.tab.checklists'),
        value: 'tarkastuslistat',
      },
      {
        label: i18n.t('admin.chain.tab.scoreCardThresholds'),
        value: 'tuloskortinrajaarvot',
      },
      {
        label: i18n.t('admin.chain.tab.toiletCheckQuestions'),
        value: 'wc-tarkastuskysymykset',
      },
      {
        label: i18n.t('admin.chain.tab.shiftResponsibilities'),
        value: 'vastuut',
      },
      {
        label: i18n.t('admin.chain.tab.chainReminders'),
        value: 'ketjun-muistutukset',
      },
      {
        label: i18n.t('admin.chain.tab.chainGeneralSettings'),
        value: 'ketjun-asetukset',
      },
      {
        label: i18n.t('admin.chain.tab.marketSettings'),
        value: 'marketin-asetukset',
      },
      {
        label: i18n.t('admin.chain.tab.campaigns'),
        value: 'kampanjat',
      },
    ]
    return tabs
  }

  getActiveTab = () => {
    const parts = this.props.location.pathname.split('/')
    return parts[parts.length - 1] || 'aloitteellisen-myynnin-tuotteet'
  }

  onTabClick = (tab) => {
    this.props.history.push(tab.value)
  }

  render() {
    const { match } = this.props

    return (
      <div className={css.component}>
        <Header
          title={i18n.t('admin.header')}
          tabs={this.getTabs()}
          tabActive={this.getActiveTab()}
          onTabClick={this.onTabClick}
        />
        <Container>
          <Switch>
            <Route exact path={`${match.path}/aloitteellisen-myynnin-tuotteet`} component={ChainIncentiveProductPage} />
            <Route exact path={`${match.path}/marketin-tehtavat`} component={MarketQuestionPage} />
            <Route exact path={`${match.path}/peukutettavat-palvelut`} component={ChainThumbableServicePage} />
            <Route
              exact
              path={`${match.path}/tuloskortinrajaarvot`}
              render={(props) => <ScoreCardThresholdsPage chainMode {...props} />}
            />
            <Route exact path={`${match.path}/tarkastuslistat`} component={ChainChecklistPage} />
            {/*
            <Route
              exact
              path={`${match.path}/test`}
              component={ChainChecklistPage}
            />
          */}
            <Route exact path={`${match.path}/wc-tarkastuskysymykset`} component={ChainToiletCheckQuestionPage} />
            <Route exact path={`${match.path}/vastuut`} component={ChainShiftResponsibilityPage} />
            <Route exact path={`${match.path}/ketjun-asetukset`} component={ChainSettings} />
            <Route path={`${match.path}/ketjun-muistutukset`} component={ChainRemindersPage} />
            <Route path={`${match.path}/marketin-asetukset`} component={ChainMarketSettingsPage} />
            <Route path={`${match.path}/kampanjat`} component={CampaignsPage} />
            <Redirect to={`${match.path}/aloitteellisen-myynnin-tuotteet`} />
          </Switch>
        </Container>
      </div>
    )
  }
}

export default withRouter(ChainRoot)
